<div class="container-fluid">
  <!-- Line Items Overview -->
  <div class="row p-0 list-header d-none d-md-flex py-3">
    <div class="col-8 col-md-8 col-xl-6">
      <div>
        {{ 'dias.onepagecheckout.product.header' | translate }}
      </div>
    </div>
    <div class="col-3 col-xl-3 d-none d-xl-block text-right" [ngClass]="{ 'justify-content-end': editable() }">
      {{ 'shopping_cart.qty.heading' | translate }}
    </div>
    <div class="col-4 col-md-4 col-xl-3 text-right">
      {{ 'shopping_cart.total.heading' | translate }}
    </div>
  </div>
  <div class="list-body">
    @for (pli of displayItems; track trackByFn(i, pli); let i = $index) {
    <custom-checkout-line-item-element
      ishProductContext
      [sku]="pli.productSKU"
      [quantity]="pli.quantity.value"
      [allowZeroQuantity]="false"
      [pli]="pli"
      [lineItemViewType]="lineItemViewType()"
      [editable]="editable() && pli.editable"
    />
    }
  </div>

  @if (showPagingBar) {
  <div class="row">
    <div
      class="col-12 d-flex grey-panel align-items-center flex-column flex-md-row justify-content-between px-3 py-2 mb-3"
    >
      <span>{{ 'shopping_cart.paging.items.label' | translate : { '0': lineItems().length } }}</span>
      <ish-paging [currentPage]="currentPage" [lastPage]="lastPage" (goToPage)="goToPage($event)" />
    </div>
  </div>
  } @if (total()?.value && lineItems().length > 0) {
  <div class="clearfix section">
    <div class="row justify-content-end list-body">
      <div class="col-sm-4 col-md-3 col-lg-2 text-right pr-0">{{ 'quote.items.total.label' | translate }}</div>
      <div class="col-sm-4 col-md-2 pr-0">
        <div class="total-price text-right">{{ total() | ishPrice }}</div>
      </div>
    </div>
  </div>
  }
</div>
